"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _Spinner = _interopRequireDefault(require("../elements/Spinner"));

var _styles = require("../styles");

var _Flex = _interopRequireDefault(require("../elements/Flex"));

var _md = require("react-icons/md");

var _Grow = _interopRequireDefault(require("../elements/Grow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "LoadingWrapper___StyledWrapper",
  componentId: "sc-9cut57-0"
})(["position:relative;", ";"], function (p) {
  return p._css;
});

var _StyledWrapper2 = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "LoadingWrapper___StyledWrapper2",
  componentId: "sc-9cut57-1"
})(["transition:0.25s opacity ", ";position:relative;z-index:1;"], _styles.easing);

var _StyledFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "LoadingWrapper___StyledFlex",
  componentId: "sc-9cut57-2"
})(["max-height:70%;position:absolute;z-index:2;", ";", ";"], _styles.centerXY, _styles.fill);

var _StyledSpinner = (0, _styledComponents["default"])(_Spinner["default"]).withConfig({
  displayName: "LoadingWrapper___StyledSpinner",
  componentId: "sc-9cut57-3"
})(["max-height:100%;"]);

function LoadingWrapper(_ref) {
  var isLoading = _ref.isLoading,
      isSuccess = _ref.isSuccess,
      cssProp = _ref.css,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["isLoading", "isSuccess", "css", "children"]);

  var _useState = (0, _react.useState)(isSuccess),
      _useState2 = _slicedToArray(_useState, 2),
      showSuccess = _useState2[0],
      setShowSuccess = _useState2[1];

  var _useState3 = (0, _react.useState)(isLoading),
      _useState4 = _slicedToArray(_useState3, 2),
      showLoading = _useState4[0],
      setShowLoading = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!showSuccess && isSuccess) {
      if (showLoading) {
        setTimeout(function () {
          setShowLoading(false);
          setShowSuccess(true);
        }, 1000);
      } else {
        setShowSuccess(true);
      }

      setTimeout(function () {
        setShowSuccess(false);
      }, 3000);
    }

    if (!showLoading && !isSuccess) {
      setShowSuccess(false);
    }

    if (!showLoading && isLoading && !showSuccess) {
      setShowLoading(true);
    }

    if (!isLoading && !showSuccess) {
      setShowLoading(false);
    }
  }, [isSuccess, isLoading]);
  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({}, props, {
    _css: cssProp
  }), /*#__PURE__*/_react["default"].createElement(_StyledWrapper2, {
    opacity: (showLoading || showSuccess) && 0.3 || 1,
    height: '100%',
    width: '100%'
  }, children), (showLoading || showSuccess) && /*#__PURE__*/_react["default"].createElement(_StyledFlex, {
    justifyContent: 'center',
    alignItems: 'center'
  }, showLoading && /*#__PURE__*/_react["default"].createElement(_StyledSpinner, {
    width: '50%',
    height: 'auto'
  }), showSuccess && /*#__PURE__*/_react["default"].createElement(_Grow["default"], {
    show: showSuccess,
    component: _md.MdCheck,
    width: '100%',
    height: '100%',
    color: _styles.success
  })));
}

var _default = LoadingWrapper;
exports["default"] = _default;